import { el, list, setAttr } from 'redom';

import Option from './option';

class SelectInputRenderer {

  constructor() {

    this.input = null;

    this.el = el('.form-editor-select-input-renderer', [
      this.renderInput()
    ]);

  }

  renderInput() {

    this.input = list('select.single-select-input', Option);
    setAttr(this.input, {
      disabled: true
    });
    return this.input;

  }

  update(inputOptions) {

    setAttr(this.input, {
      placeholder: inputOptions.placeholder || ''
    });

    this.input.update(inputOptions.options);

  }

}

export default SelectInputRenderer;